import React from 'react';
import styled, { css } from 'styled-components';
import Theme from '../../theme';
import IconTick from '../../../src/assets/svgs/tick.svg';
var Box = styled.div.withConfig({
  displayName: "SelectBox__Box",
  componentId: "sc-vkq47w-0"
})(["display:flex;height:100%;position:relative;border-radius:3px;background-color:", ";color:", ";cursor:", ";", ";", ";:hover{", ";}"], function (props) {
  return props.disabled ? "" + Theme.colours.grey_f5 : "" + Theme.colours.white;
}, function (props) {
  return props.disabled ? "" + Theme.colours.grey_c6 : "" + Theme.colours.black;
}, function (props) {
  return props.disabled ? 'not-allowed' : 'pointer';
}, function (props) {
  return props.active && props.showTick && css(["::after{content:'';width:0;height:0;border-left:20px solid transparent;border-right:20px solid transparent;border-bottom:20px solid ", ";position:absolute;top:-3.5px;right:-13px;transform:rotate(45deg);}"], Theme.colours.linkblue);
}, function (props) {
  return props.active ? css(["border:2px solid ", ";overflow:hidden;"], Theme.colours.linkblue) : css(["border:1px solid ", ";padding:1px;"], Theme.colours.grey_d6);
}, function (props) {
  var styledBorder = '';
  if (!props.active) styledBorder = "border: 1px solid " + Theme.colours.linkblue_l2 + ";";
  if (props.presentational) styledBorder = "\n          border: 1px solid " + Theme.colours.grey_d6 + "; \n          cursor: unset;\n        ";
  if (props.disabled) styledBorder = "border: 1px solid " + Theme.colours.grey_d6 + ";";
  return styledBorder;
});
var Tick = styled.span.withConfig({
  displayName: "SelectBox__Tick",
  componentId: "sc-vkq47w-1"
})(["position:absolute;display:inline-block;top:-1px;right:-1px;z-index:1;"]);

var SelectBox = function SelectBox(_ref) {
  var active = _ref.active,
      showTick = _ref.showTick,
      disabled = _ref.disabled,
      className = _ref.className,
      onClick = _ref.onClick,
      children = _ref.children,
      presentational = _ref.presentational;
  return /*#__PURE__*/React.createElement(Box, {
    onClick: onClick,
    className: className,
    role: "button",
    active: active,
    showTick: showTick,
    disabled: disabled,
    presentational: presentational
  }, active && showTick && /*#__PURE__*/React.createElement(Tick, null, /*#__PURE__*/React.createElement(IconTick, {
    fill: Theme.colours.white
  })), children);
};

export default SelectBox;